import { Upload, Progress, message, Button } from "antd";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getAllLeadDoc } from "../../../redux/AddLeadDocument/action";

const UploadDoc = ({
  beforeUpload,
  onRemove,
  showUploadList,
  onChange,
  defaultFileList,
  disabled,
  endPoint,
  params,
  extraText,
  refreshDocsAPI,
  key,
  panVerificationStatus,
  applicantHasPanCardFlag,
  callBackAPI,
  handleEditChange,
  isVerified,
  setVerified,
  dmsDocTypeName,
  ...props
}) => {
  const [progress, setProgress] = useState(0);

  const location = useLocation();
  const id = location?.state?.leadId;

  const [uploadText, setUploadText] = useState(
    callBackAPI ? "Save & Upload" : "Upload"
  );

  const dispatch = useDispatch();

  const changeUploadTxt = () => {
    setUploadText(callBackAPI ? "Change/Edit" : "Change");
  };

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // Size limit 10 MB

  const beforeUploadS = (file) => {
    const filesFormats = ["image/png", "image/jpeg", "application/pdf"];

    const docFieldName =
      dmsDocTypeName?.dmsDocTypeName === "Bank Document" ||
      dmsDocTypeName?.dmsDocTypeName === "Lead Bank Doc";

    const isRightFormat = filesFormats.includes(file.type);

    if (!isRightFormat) {
      message.error("You can only upload pdf, jpg and jpeg files");
      return isRightFormat;
    }
    const isLt2M = file.size / 1024 / 1024 < (docFieldName ? 30 : 10);

    if (!isLt2M) {
      message.error(
        `The selected file exceeds the allowed limit of ${
          docFieldName ? 30 : 10
        }MB. Please choose a smaller file`
      );
      return isLt2M;
    }
  };

  const uploadDocsNewWay = async (options) => {
    // if (isVerified) {
    //   handleEditChange();
    //   return;
    // }

    const { onSuccess, onError, file } = options;
    let data = new FormData();
    data.append("file", file);
    if (panVerificationStatus) {
      data.append("applicantHasPanCardFlag", applicantHasPanCardFlag);
    }
    try {
      const res = await axios({
        method: "post",
        url: `${endPoint}`,
        headers: {
          authorization: "Bearer " + props.accessToken,
          "Content-Type": "multipart/form-data",
        },
        params: params,
        data: data,
        // onUploadProgress: (event) => {
        //   const percent = Math.floor((event.loaded / event.total) * 100);
        //   setProgress(percent);
        //   if (percent === 100) {
        //     setTimeout(() => setProgress(0), 1000);
        //   }
        //   onProgress({ percent: (event.loaded / event.total) * 100 });
        // },
      });
      if (res.status === 200) {
        onSuccess("Ok");
        changeUploadTxt();
        if (callBackAPI) {
          callBackAPI();
        } else {
          refreshDocsAPI && refreshDocsAPI();
        }

        message.success(`${file.name} file uploaded successfully`);
        // Call getAllLeadDoc API here
        // setTimeout(function () {
        //   window.location.reload();
        // }, 2000); // Replace 2000 with the desired delay in milliseconds (2 seconds in this example)

        getAllLeadDoc();
      }
    } catch (err) {
      if (err.response) {
        onError({ err });
        message.error(err.response.data.error.message);
        return err.response;
      } else {
        onError({ err });
      }
    }
  };

  const getAllLeadDoc = () => {
    props.getAllLeadDoc({
      access_token: props.auth?.accessToken?.access_token,
      leadId: id,
    });
  };

  useEffect(() => {
    if (defaultFileList?.length > 0) {
      changeUploadTxt();
    }
  }, [defaultFileList]);

  return (
    <div style={{ display: "", justifyContent: "end", textAlign: "end" }}>
      <Upload
        key={key ? key : ""}
        listType="text"
        className="selected-optdoc"
        showUploadList={showUploadList}
        defaultFileList={defaultFileList}
        accept=".pdf,.png,.jpg"
        beforeUpload={beforeUploadS}
        // onRemove={onRemove}
        customRequest={uploadDocsNewWay}
        disabled={disabled}
        onChange={(e) => {
          onChange(e);
        }}
        maxCount={1}
      >
        {!isVerified && (
          <Button className="submit-primary-btn mb-0" disabled={disabled}>
            {uploadText} {extraText && extraText}
          </Button>
        )}
      </Upload>
      {/* {progress > 0 ? <Progress percent={progress} /> : null} */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    state: state && state.auth,
    accessToken: state?.auth?.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllLeadDoc: (data) => dispatch(getAllLeadDoc(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadDoc);
